<template>
  <div class="modal__content">
    <div class="image_onboarding_employee">
      <SecondImageOnBoarding />
    </div>
    <div class="content_onboarding_employee_second_onboarding">
      <div class="container_onboarding_title_second_onboarding">
        <div class="title_onboarding_employee">
          Personaliza los accesos de tu equipo
        </div>
      </div>
      <div class="text_container_onboarding_second">
        <div class="">
          1. Los <b>“miembros”</b> son registro de tu equipo completo con sus
          datos personales. Puedes subir a todos los miembros que necesites.
        </div>
        <div class="">
          2. Si quieres que algunos miembros de tu equipo puedan acceder a la
          plataforma debes registrarlos como <b>“usuarios”</b> así ellos podrán
          ingresar, ver su información y documentos asociados.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecondImageOnBoarding from "./assets/Second_step_onboarding.svg";
import { mapGetters } from "vuex";

export default {
  props: ["size"],
  components: {
    SecondImageOnBoarding,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters("EmployeesV2", {
      stepEmployeesOnBoarding: "stepEmployeesOnBoarding",
    }),
  },
  methods: {
    AcceptOnBoarding() {
      let increment = this.stepEmployeesOnBoarding + 1;

      this.$store.dispatch(
        "EmployeesV2/counterStepEmployeeOnBoarding",
        increment
      );
    },
    cancelModal() {
      let modal = document.querySelector("#modal__onboarding__employee");
      modal.setAttribute("closing", "");
      modal.addEventListener(
        "animationend",
        () => {
          modal.removeAttribute("closing");
          modal.close();
        },
        { once: true }
      );
    },
  },
};
</script>
<style lang="scss">
@import "./onBoarding.scss";
</style>
